import {Typography } from '@material-ui/core'
import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import CustomizedDialogs from '../dialog'
import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from "@material-ui/core/styles";
import CliniqueService from '../../services/CliniqueService'
import { toast } from "react-toastify";
import FamilleForm from '../FamilleForme'



const Famille = () => {
    const useStyles = makeStyles({
        root: {
          maxWidth: 345,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent:'center',
        }
      });
 
  const classes = useStyles();
  const [formes,setFormes] = useState([])


  useEffect(() => {
    const fetchData = async () => {
       await CliniqueService.getFamilles()
          .then((response) => {
            setFormes(response.data)
          })
          .catch(e => {
            console.log(e);
         });
        }

        
     fetchData();
  }, [])
   

      const refreshFormes = async ()=>{
        await CliniqueService.getFamilles()
           .then((response) => {
            setFormes(response.data)
            })
            .catch(e => {
              console.log(e);
            });
      }

    
    

  const columns = [
     { title: "NOM FAMILLE", field: "intituleFam", filterPlaceholder: "filter" },
     { title: "CREATEUR", field: "speudo",filterPlaceholder:"filter",editable: 'never' },
     //{ title: "Enregistre", field: "dateEng", type: "currency", currencySetting: { currencyCode: "INR", minimumFractionDigits: 1 },
     // cellStyle: { background:"#009688" }, headerStyle: { color: "#fff" } },
   ]

    return (
        <div className="App" style={{width:"100%", display:'flow',justifyContent:'center',alignItems:'center',top:0,bottom:0,margin:'auto'}}>
            <Typography variant="title" className={classes.title}>
            Liste des familles pharmaceutiques
            </Typography>
            <div style={{display:"flex",justifyContent:'flex-start',margin:15}}>
        <div>
         <CustomizedDialogs title="Nouvelle famille" boutonTitle="Ajouter une famille" refresh={()=>refreshFormes()}>
                   <FamilleForm />
       </CustomizedDialogs>
      </div>
        </div>
            <MaterialTable columns={columns} data={formes}
      onRowClick={(evt,rowData)=>{
        //setSelectedRow(rowData)
        //setShowDialog(true)
       /*  history.push(
          {
            pathname: '/report',
            state: { data: rowData }
          }
        ) */
      }}
        editable={{
          onRowAdd: (newRow) => new Promise((resolve, reject) => {
              CliniqueService.createFamille(newRow)
                  .then((response) => {
                    toast.success("Famille pharmaceutique ajoutee avec success...", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshFormes()
                  })
                  .catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data, {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                  });
            refreshFormes()
            setTimeout(() => resolve(), 500)
          }),
          onRowUpdate: (newRow, oldRow) => new Promise((resolve, reject) => {
            
              CliniqueService.updateFamille(newRow,oldRow.id)
                  .then((response) => {
                    toast.success("Famille pharmaceutique modifie avec success...", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshFormes()
                  })
                  .catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data, {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                  });
            refreshFormes()
            setTimeout(() => resolve(), 500)
          }),
          onRowDelete: (selectedRow) => new Promise((resolve, reject) => {
            CliniqueService.deleteFamille(selectedRow.id)
                  .then((response) => {
                    toast.success("Famille pharmaceutique supprimee avec success...", {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    refreshFormes()
                  })
                  .catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data, {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    });
                  });
            setTimeout(() => resolve(), 1000)
          })
        }}
        actions={[
          {
            icon: () => <GetAppIcon />,
            tooltip: "details",
            onClick: (event, rowData) => {
              console.log(rowData)
            },
            
          }
        ]}
        onSelectionChange={(selectedRows) => console.log(selectedRows)}
        options={{
          sorting: true, search: true,
          searchFieldAlignment: "right", searchAutoFocus: true, searchFieldVariant: "standard",
          filtering: true, paging: true, pageSizeOptions: [2, 5, 10, 20, 25, 50, 100], pageSize: 5,
          paginationType: "stepped", showFirstLastPageButtons: false, paginationPosition: "both", exportButton: true,
          exportAllData: true, exportFileName: "Fournisseurs", addRowPosition: "first", actionsColumnIndex: -1, selection: true,
          showSelectAllCheckbox: false, showTextRowsSelected: false, selectionProps: rowData => ({
            //disabled: rowData.age == null,  
            color:"primary"
          }),
           columnsButton: true,
          rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
          headerStyle: { background: "#226D68",color:"#fff"},
          
        }}
        title="Liste des familles pharmaceutiques "
        icons={{ Add: () => <AddIcon /> }} />
          </div>
    )
}

export default Famille
